import React from 'react';
import { FullColoredTicketButton, TicketActionButton } from 'components/common/buttonsComponents';
import { StyledButtonsContainer } from './DropdownNodeButtons.styles';

export const DropdownNodeButtons = ({
  currentlyActiveNode,
  totalNodesCount,
  nextButtonDisabled,
  saveButtonDisabled,
  setCurrentlyActiveNode = () => {},
}) => {
  const switchNode = (toNext) => {
    if (toNext && currentlyActiveNode < totalNodesCount) {
      setCurrentlyActiveNode(currentlyActiveNode + 1);
    }

    if (!toNext && currentlyActiveNode > 0) {
      setCurrentlyActiveNode(currentlyActiveNode - 1);
    }
  };

  return (
    <StyledButtonsContainer>
      {/* hide Previous button if the first node is being displayed */}
      {currentlyActiveNode > 0 && (
        <TicketActionButton className="previous" onClick={() => switchNode(false)} type="button">
          Previous
        </TicketActionButton>
      )}
      {/* hide Next button and render Save button if the last node is being displayed */}
      {currentlyActiveNode !== totalNodesCount && (
        <FullColoredTicketButton active disabled={nextButtonDisabled} onClick={() => switchNode(true)} type="button">
          Next
        </FullColoredTicketButton>
      )}
      {currentlyActiveNode === totalNodesCount && (
        <FullColoredTicketButton active disabled={saveButtonDisabled} type="submit">
          Save
        </FullColoredTicketButton>
      )}
    </StyledButtonsContainer>
  );
};

export default DropdownNodeButtons;
